import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import "../styles/RegistrationSuccessful.css";

import { useUser } from "../context/UserContext";

const RegistrationSuccess = () => {
  const navigate = useNavigate();
  const {user } = useUser();

  return (
    <div className="success-container">
      <div className="success-card">
        <FaCheckCircle className="success-icon" />
        <h2>Registration Successful 🎉</h2>
        <p>
          Thank you for registering your business with us.  
          Our onboarding team is setting up your platform,  
          and you will be notified once the process is completed.
        </p>
        <p className="redirect-note">
          Please note that we may contact you for any further information regarding your business.
        </p>
        {
          user 
          ? 
            <div className="row">
              <div className="col-6">
                <button className="btn btn-primary w-100"
                  onClick={()=> {navigate("/choose-profile")}}>
                  View Profiles
                </button>
              </div>
              <div className="col-6">
                <button className="btn btn-primary w-100"
                  onClick={()=> {navigate("/contact")}}>
                  Contact Us
                </button>
              </div>
            </div>
          : <>
              <p>Check your email for the login credentials</p> 
            <div className="row">
              <div className="col-6">
                <button className="btn btn-primary w-100"
                  onClick={()=> {navigate("/login")}}>
                  Login
                </button>
              </div>
              <div className="col-6">
                <button className="btn btn-primary w-100"
                  onClick={()=> {navigate("/contact")}}>
                  Contact Us
                </button>
              </div>
            </div>
            </>
        }
        
      </div>
    </div>
  );
};

export default RegistrationSuccess;
